import { useFlags } from 'launchdarkly-react-client-sdk'
import { useMemo } from 'react'
import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

import { faArrowRight, faXmark } from '@fortawesome/pro-light-svg-icons'

import { FEATURE_FLAGS } from '@infura/packages.common/constants'

import useVisibilityCookie from 'hooks/useVisibilityCookie'

const IPFS_SURVEY_BANNER = 'IPFS_SURVEY_BANNER_KEY'

/**
 * Renders a banner which links to IPFS survey
 */
export const SurveyBanner = () => {
  const [shouldShowBanner, toggleBanner] = useVisibilityCookie(IPFS_SURVEY_BANNER)

  const flags = useFlags()
  const featureFlag = useMemo(() => flags[FEATURE_FLAGS.IPFS_SURVEY_BANNER], [flags])

  if (!featureFlag) {
    return null
  }

  if (!shouldShowBanner) {
    return null
  }

  return (
    <div className='bg-primary-default flex w-full justify-between px-4 py-2'>
      <span className='hidden lg:block' />
      <span className='flex gap-2'>
        <span>
          <a
            className='text-text-default hover:text-text-default font-bold'
            data-testid='ipfs-banner-link'
            href='https://forms.gle/LdVxwNnYXUh3pSJY7'
          >
            Help us build the future of decentralized storage with IPFS! Fill out a short survey.
          </a>
          <FontAwesomeIcon className='text-text-default ml-2 mt-1' icon={faArrowRight} />
        </span>
      </span>
      <button
        className='mt-1 flex lg:mt-0 lg:items-center lg:justify-end lg:gap-2'
        onClick={() => {
          toggleBanner()
        }}
      >
        <FontAwesomeIcon className='text-white' icon={faXmark} />
        <label className='sr-only'>Dismiss</label>
      </button>
    </div>
  )
}
